import React, { HTMLAttributes } from 'react'
import MapLoader from '../Map/Loader';

interface ILoadingProps extends HTMLAttributes<HTMLDivElement> {
  isLoading?: boolean
}

export const Loading: React.FC<ILoadingProps> = ({ isLoading = true, className, ...rest }) => {
  return (
    <div className={`w-10 h-10 relative ${!isLoading && 'hidden'} ${className}`} {...rest}>
      <div className="w-full h-full rounded-full bg-primary opacity-60 absolute top-0 animate-loader-element"></div>
      <div style={{ 'animationDelay': '-1s' }} className="w-full h-full rounded-full bg-primary opacity-60 absolute top-0 animate-loader-element delay-1000"></div>
      <div className="w-full h-full rounded-full bg-primary opacity-60 absolute top-0 animate-loader-element"></div>
    </div>
  )
}
